import {isLargeScreen, isTouchDevice} from "surveylabJsAssets/common/_globals";

class Slider {
    protected sliderElementFocusFlag: boolean = false;
    protected sliderElementSlidingFlag: boolean = false;

    protected initialized: boolean = false;

    public initOnce(): void {
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        const _this = this;

        $(function () {
            /**
             * Threshold to detect vertical scrolling.
             *
             * @type {number}
             */
            const verticalScrollingThreshold = 6;

            if (isTouchDevice()) {
                // Trigger an event if vertical scrolling is happening on a touch device
                let touchStartY = 0;
                $(this).on('touchstart', function (e) {
                    //noinspection JSUnresolvedVariable
                    touchStartY = e.originalEvent.changedTouches[0].pageY;
                });
                $(this).on('touchmove', function (e) {
                    //noinspection JSUnresolvedVariable
                    const deltaY = touchStartY - e.originalEvent.changedTouches[0].pageY;
                    //noinspection JSSuspiciousNameCombination
                    if (Math.abs(deltaY) > verticalScrollingThreshold) {
                        $(this).trigger('verticalScrolling');
                    }
                });
            } else {
                $('main').addClass('sl-desktop-device');
            }
        });

        // Adjust the widths of the options, labels and the sliders
        // As of jquery 3, the load event cannot be inside document ready anymore, see https://github.com/jquery/jquery/issues/3194
        $(window).on("load", function () {
            _this.adjustElements();
            _this.initStickyTableHeaders();

            $(this).on('resize', function () {
                // Don't adjust elements after window resizing immediatly,
                // so that it's not done multiple times, especially in order to
                // fix adjustment problems when changing the orientation on touch devices.
                // @see https://stackoverflow.com/a/13244739
                clearTimeout($.data(this, 'resizeTimer'));
                $.data(this, 'resizeTimer', setTimeout(function () {
                    _this.destroyStickyTableHeaders();
                    _this.adjustElements();
                    _this.initStickyTableHeaders();
                    _this.updateStickyTableHeaders();
                }, 10));
            });


            // Handle slider elements that were previously hidden and are now shown
            $('.sl-js-slider').each(function () {
                $(this).closest('.sl-survey-element').on('show', function () {
                    _this.destroyStickyTableHeaders();
                    _this.adjustElement($('.sl-js-outer-table', $(this)));
                    _this.initStickyTableHeaders();
                    _this.updateStickyTableHeaders();
                });
            });

            $(document).on('scroll', function () {
                _this.updateStickyTableHeaders();
            });
        });
    }

    protected adjustElements(): void {
        const _this = this;
        // Set width and padding
        $('.sl-js-slider .sl-js-outer-table').each(function () {
            _this.adjustElement($(this));
        });
    }

    protected adjustElement($outerTable: JQuery): void {
        this.setOptionWidth($outerTable);
        this.setLabelWidth($outerTable);
        this.setSliderPadding($outerTable);
    }

    protected setOptionWidth($outerTable: JQuery): void {
        /**
         * @type {number}
         */
        const sliderOptionWidthLargeScreen = 80; // px

        const $optionsContainer = $('.sl-js-header-options-row > th', $outerTable);
        const $optionsTable = $('.sl-options-container table', $optionsContainer);
        const $optionsRow = $('tr', $optionsTable);
        const optionsCount = $('.sl-js-option-column', $optionsRow).length;
        let colWidth: number;
        if (isLargeScreen()) {
            colWidth = sliderOptionWidthLargeScreen;
        } else {
            colWidth = $optionsTable.outerWidth(false) / optionsCount;
        }
        $('.sl-js-option-column', $optionsRow).each(function () {
            $(this).css('width', colWidth + 'px');
        });
    }

    protected setLabelWidth($outerTable: JQuery): void {
        const $optionsContainer = $('.sl-js-header-options-row > th', $outerTable);
        const $optionsElement = $('.sl-options-container > div', $outerTable);
        const $optionsTable = $('table', $optionsElement);
        if (isLargeScreen()) {
            const labelMinWidth = $optionsContainer.outerWidth(false) - $optionsTable.outerWidth(false);
            $optionsElement.css('margin-left', labelMinWidth + 'px');
            $('.sl-label-column', $outerTable).each(function () {
                $(this).css('min-width', labelMinWidth + 'px');
            });
        } else {
            $optionsElement.css('margin-left', '');
            $('.sl-label-column', $outerTable).each(function () {
                $(this).css('min-width', '');
            });
        }
    }

    protected setSliderPadding($outerTable: JQuery): void {
        const $optionsElement = $('.sl-options-container > div', $outerTable);
        const $optionsRow = $('table tr', $optionsElement);
        const $sliderContainer = $('.sl-slider-column', $outerTable);
        const $firstOptionCell = $('.sl-js-option-column:first-child', $optionsRow);
        const $lastOptionCell = $('.sl-js-option-column:last-child', $optionsRow);
        const sliderPaddingLeft = ($firstOptionCell.outerWidth(false) / 2) + 'px';
        const sliderPaddingRight = ($lastOptionCell.outerWidth(false) / 2) + 'px';
        const sliderMinWidth = $optionsElement.outerWidth(false) + 'px';
        $sliderContainer.each(function () {
            $(this).css('min-width', sliderMinWidth);
            $(this).css('padding-left', sliderPaddingLeft);
            $(this).css('padding-right', sliderPaddingRight);
        });
    }


    /**
     * Clone table header as floating header.
     */
    protected initStickyTableHeaders(): void {
        $('.sl-js-slider .sl-js-outer-table').each(function () {
            const $tableHeader = $('> thead', $(this));
            const tableHeaderWidth = $tableHeader.width();
            const optionsTableWidth = $('table', $tableHeader).width();
            const $tableHeaderClone = $tableHeader.before($tableHeader.clone());
            $tableHeaderClone.addClass('sl-floating-header')
                .css({
                    'width': tableHeaderWidth,
                    'top': $('nav').height()
                });
            $('table', $tableHeaderClone).css('width', optionsTableWidth);
        });
    }

    protected destroyStickyTableHeaders(): void {
        $('.sl-floating-header').remove();
    }

    protected updateStickyTableHeaders(): void {
        $('.sl-js-slider .sl-js-outer-table').each(function () {
            const navbarHeight = $('nav').height();
            const tableBodyHeight = $('> tbody', $(this)).height();
            const tableOffsetTop = $(this).offset().top;
            const scrollTop = $(window).scrollTop();
            const $originalHeader = $('> thead:not(.sl-floating-header)', $(this));
            const $floatingHeader = $('> thead.sl-floating-header', $(this));

            if ((scrollTop + navbarHeight > tableOffsetTop) &&
                (scrollTop + navbarHeight <= tableOffsetTop + tableBodyHeight)) {
                $originalHeader.css('visibility', 'hidden');
                $floatingHeader.css('visibility', 'visible');
            } else {
                $originalHeader.css('visibility', 'visible');
                $floatingHeader.css('visibility', 'hidden');
            }
        });
    }

    // end slider base init function

    /**
     * This is a wrapper function to call the slider by one of the two
     * possible namespaces 'bootstrapSlider' or 'slider'.
     *
     * Bootstrap slider automatically uses the namespace 'bootstrapSlider'
     * if the namespace 'slider' is already taken (e.g. in the questionnare
     * overview).
     *
     * @see https://github.com/seiyria/bootstrap-slider#what-if-there-is-already-a-slider-plugin-bound-to-the-jquery-namespace
     */
    public bootstrapSlider(obj: JQuery, args: any[]): any {
        if (typeof obj.bootstrapSlider === "function") {
            return (<SliderPlugin<JQuery>>obj.bootstrapSlider).apply(obj, args);
        } else {
            return obj.slider.apply(obj, args);
        }
    };

    public setValue(slider: JQuery, value: number): void {
        const $sliderElement = slider.closest('.sl-js-bootstrap-slider');
        const itemElementID = $sliderElement.data("item-element-id");
        const $inputElement = $('#' + itemElementID, slider.closest('.sl-slider-column'));
        $inputElement.val(value);
        $inputElement.trigger('change');
    };

    public showHandle(slider: JQuery): void {
        const $sliderHandle = $('.min-slider-handle', this.bootstrapSlider(slider, ['getElement']));
        $sliderHandle.css('background-color', '');
    };


    public hideHandle(slider: JQuery): void {
        const $sliderHandle = $('.min-slider-handle', this.bootstrapSlider(slider, ['getElement']));
        $sliderHandle.css('background-color', 'rgba(0, 0, 0, 0)'); // transparent background
    };

    public isHandleHidden(slider: JQuery): boolean {
        const handleBackground = $('.min-slider-handle', this.bootstrapSlider(slider, ['getElement'])).css('background-color');
        return handleBackground === 'rgba(0, 0, 0, 0)' || handleBackground === 'transparent';
    };

    public markActiveSliderRow($row: JQuery): void {
        $row.addClass('sl-row-hover');
        $row.removeClass('sl-row-no-hover');
    };

    public unmarkInactiveSliderRow($row: JQuery): void {
        $row.addClass('sl-row-no-hover');
        $row.removeClass('sl-row-hover');
    };

    /**
     * Sets the status whether there is a slider element that is currently sliding (sliding started but has not stopped yet).
     */
    public sliderIsSliding(isSliding: boolean): void {
        this.sliderElementSlidingFlag = isSliding;
    };

    /**
     * Returns whether there is a slider element that is currently sliding (sliding started but has not stopped yet).
     */
    public isSliderSliding(): boolean {
        return this.sliderElementSlidingFlag;
    };

    /**
     * Sets the status whether there is a slider element that has the current focus.
     */
    public sliderHasFocus(hasFocus: boolean): void {
        this.sliderElementFocusFlag = hasFocus;
    };

    /**
     * Returns whether there is a slider element that has the current focus.
     */
    public hasSliderFocus(): boolean {
        return this.sliderElementFocusFlag;
    }
}

export default new Slider();